module.exports = __webpack_public_path__ + "Wireframes11.png?e0e46f51bc0e355b26705606eb7fe6b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes11.png
// module id = 110
// module chunks = 0